* {
    box-sizing: border-box;
}

:host {
    display: contents;
}

.important {
    color: var(--color-error);
}

.type_to_confirm {
    border: 2px solid var(--color-shade-20);
    border-radius: 20px;
    padding: 20px;
    display: block;
}

.type_to_confirm pre {
        display: inline;
        background-color: var(--color-shade-10);
        padding: 4px;
        border-radius: 4px;
    }

.type_to_confirm input {
        height: 40px;
        border-radius: 20px;
        width: 100%;
        margin-top: 16px;

        border-width: 1px;
        border-style: solid;
        border-color: var(--color-shade-60);
        outline: none;
        padding: 0 20px;
        transition-property: border-color;
        transition-duration: 500ms;
        transition-timing-function: ease;

        font-family: inherit;
        font-weight: 400;
        font-size: 16px;
        color: var(--color-text);
        background-color: var(--color-background);
    }

.type_to_confirm input:disabled {
            color: var(--color-disabled-contrast);
            border-color: var(--color-disabled-border);
            background-color: var(--color-disabled);
            border-style: dashed;
        }

.type_to_confirm input:focus {
            border-color: var(--color-secondary);
        }

.type_to_confirm input::-moz-placeholder {
            color: var(--color-shade-60);
        }

.type_to_confirm input::placeholder {
            color: var(--color-shade-60);
        }

.inner {
    opacity: 0;
    border: none;
    border-radius: 4px;
    position: relative;
    box-shadow: none;
    padding: 10px;
    background-color: var(--color-text);
    color: var(--color-background);
}

.inner.entered {
        animation: 1s linear 0s 1 forwards animate-up;
    }

@keyframes animate-up {
    from {
        opacity: 0;
        transform: translateY(0);
    }
    30% {
        opacity: 1;
    }
    70% {
        opacity: 1;
    }
    to {
        opacity: 0;
        transform: translateY(-10px);
    }
}
